import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './Document.intl';
import alternateImage from 'common/images/report_bg.svg';

import styles from './Document.module.scss';

@injectIntl
export default class DocumentComponent extends Component {
  static defaultProps = {
    className: ''
  };
  static propTypes = {
    className: PropTypes.string,
    document: PropTypes.object.isRequired
  };

  render() {
    const { className, document } = this.props;
    return (
      <div className={`${styles.DocumentBox} ${className}`}>
        <div
          className={styles.Image}
          style={{
            backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
              alternateImage
            )})`
          }}
        />
        <div className={styles.Info}>
          <h2 className={styles.Title}>{document.description}</h2>
          {document &&
            document.attachments.map(attachment => (
              <a
                className={styles.URL}
                href={attachment.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {this.props.intl.formatMessage(messages.downloadAlternateText)}:{' '}
                {attachment.name}
              </a>
            ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Document/Document.js